<template>
  <div>
    <label class="label">{{ title }}</label>
    <b-button @click="browse" type="is-primary" class="mb-3" expanded
      >Browse</b-button
    >
    <input
      type="file"
      accept="image/*"
      class="is-hidden"
      ref="file"
      @change="change"
    />
    <div class="image-container" style="max-height: 500px; width: 100%">
      <img :src="src" style="max-height: 500px; object-fit: contain" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    title: String,
    defaultSrc: String,
    name: String,
  },
  data() {
    return {
      src: this.defaultSrc,
      file: null,
    };
  },
  methods: {
    browse() {
      this.$refs.file.click();
    },
    change(e) {
      this.$emit('input', e.target.files[0]);
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (e) => {
        this.src = e.target.result;
      };
      this.$emit('image-uploaded', {
        file: e.target.files[0],
        name: this.name,
      });
    },
  },
};
</script>
